(() => {
  if (customElements.get('avontic-ipad-extras')) return;
  class IpadExtras extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      try { this.source = JSON.parse(this.querySelector('[data-av-bundle-product-data]').textContent); }
      catch { this.source = { options: [] }; }
      this.addEventListener('change', event => {
        if (event.target.matches('[data-extras-variant]')) this.updateCard(event.target);
      }, { signal });
      this.addEventListener('click', event => {
        const upgrade = event.target.closest('[data-extras-upgrade]');
        if (upgrade) this.chooseUpgrade(upgrade);
        const link = event.target.closest('a');
        if (link) this.keepPreview(link);
      }, { signal });
      this.addEventListener('toggle', event => {
        if (!event.target.matches('.av-extras__choices') || !event.target.open) return;
        this.querySelectorAll('.av-extras__choices[open]').forEach(el => { if (el !== event.target) el.open = false; });
      }, { capture: true, signal });
      this.addEventListener('variant:add', event => {
        const card = event.target.closest('[data-extras-kind]');
        if (card) document.dispatchEvent(new CustomEvent('avontic:optional-extra-added', { detail: { source: this.dataset.sourceHandle, accessory: card.dataset.extrasKind } }));
      }, { signal });
      const sync = () => this.syncIncluded();
      ['variant:change', 'product:variant-change', 'variant:changed', 'shopify:section:load'].forEach(name => document.addEventListener(name, sync, { signal }));
      document.addEventListener('change', event => {
        if (!event.target.closest('variant-picker')) return;
        sync();
        clearTimeout(this.syncTimer);
        this.syncTimer = setTimeout(sync, 120);
      }, { signal });
      this.syncIncluded();
    }
    disconnectedCallback() { this.abort?.abort(); clearTimeout(this.syncTimer); }
    keepPreview(link) {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      const current = new URL(location.href);
      ['preview_theme_id','_ab','_fd','_sc','currency','country'].forEach(key => { if(current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key)); });
      link.href = url.href;
    }
    updateCard(select) {
      const card = select.closest('[data-extras-kind]');
      if (card.dataset.extrasKind === 'privacy_work') {
        const button = card.querySelector('button[type="submit"]');
        if (button) button.disabled = !select.value || !!select.selectedOptions[0]?.disabled;
      }
      const price = card.querySelector(`[data-extras-price-for="${select.value}"]`);
      if (price) card.querySelector('[data-extras-price]').replaceChildren(price.content.cloneNode(true));
      const option = select.selectedOptions[0];
      const image = card.querySelector('.av-extras__image img');
      if (option?.dataset.image && image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
        image.alt = option.dataset.alt || '';
      }
    }
    selectedOptions() {
      const picker = [...document.querySelectorAll('variant-picker')].find(el => el.getAttribute('form-id') === this.dataset.sourceForm || el.getAttribute('handle') === this.dataset.sourceHandle);
      return this.source.options.map(option => {
        const input = picker?.querySelector(`input[data-option-position="${option.position}"]:checked,select[data-option-position="${option.position}"]`);
        return { name: option.name, value: option.values.find(v => input && String(v.id) === input.value)?.name || option.values.find(v => v.selected)?.name || '' };
      });
    }
    chooseUpgrade(button) {
      const kind = button.dataset.extrasUpgrade;
      const option = this.source.options.find(o => kind === 'privacy' ? o.name === 'Screen Protection' : ['Stylus Option','Setup'].includes(o.name));
      let candidates = option?.values.filter(v => kind === 'privacy' ? /privacy/i.test(v.name) : /stylus/i.test(v.name) && !/no stylus/i.test(v.name)) || [];
      if (candidates.length > 1) {
        const pack = this.selectedOptions().find(o => o.name === 'Pack')?.value.match(/^\d+/)?.[0];
        if (pack) candidates = candidates.filter(v => v.name.startsWith(pack + ' '));
      }
      const picker = [...document.querySelectorAll('variant-picker')].find(el => el.getAttribute('form-id') === this.dataset.sourceForm);
      const input = candidates.length === 1 && picker?.querySelector(`input[data-option-position="${option.position}"][value="${candidates[0].id}"]`);
      if (input && !input.disabled) {
        input.click();
        // The theme owns option availability, price, URL and variant refresh.
        this.syncIncluded();
        picker.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        picker.setAttribute('tabindex','-1');
        picker.focus({ preventScroll: true });
      } else {
        button.closest('article').querySelector('[data-upgrade-status]').textContent = 'Choose your bundle options above to check availability for this configuration.';
        picker?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
    syncIncluded() {
      const included = this.dataset.baseIncluded || '';
      const has = { keyboard: included.includes('keyboard'), stylus: included.includes('stylus'), privacy: included.includes('privacy') };
      for (const option of this.selectedOptions()) {
        const value = option.value.toLowerCase();
        if (this.dataset.dynamicStylus === 'true' && ['Stylus Option','Setup'].includes(option.name)) has.stylus = value.includes('stylus') && !value.includes('no stylus');
        if (this.dataset.dynamicPrivacy === 'true' && option.name === 'Screen Protection') has.privacy = value.includes('privacy');
      }
      for (const kind of ['keyboard','stylus','privacy']) {
        const badge = this.querySelector(`[data-included="${kind}"]`);
        if (badge) badge.hidden = !has[kind];
        const card = this.querySelector(`[data-extras-kind="${kind}"]`);
        if (card) { card.hidden = has[kind]; if (has[kind]) card.querySelectorAll('details').forEach(el => { el.open = false; }); }
      }
      const row = this.querySelector('[data-extras-included]');
      if (row) row.hidden = !Object.values(has).some(Boolean);
    }
  }
  customElements.define('avontic-ipad-extras', IpadExtras);
})();
